<div class="lmo-frac-list">
  <div class="list-header">
    <div class="hide-handheld flex flex-row justify-between w-full items-center">
      <h2 class="pl-2 text-white">Wells</h2>
      <ng-container *saAllowedAccountRoles="['admin', 'dispatcher']">
        <div class="flex flex-row gap-1">
          <button mat-flat-button color="primary" [matMenuTriggerFor]="sortMenu">Sort</button>
          <button mat-flat-button color="primary" [routerLink]="['/', 'wells']">View Archived Wells</button>
          <button
            mat-flat-button
            color="primary"
            *saAllowedAccountRoles="[1, 2, 9, 10]"
            [routerLink]="['/', 'wells', 'edit', 'new']"
          >
            Create New Frac
          </button>
        </div>
      </ng-container>
      <ng-container *saAllowedAccountRoles="['default']">
        <button mat-flat-button color="primary" [routerLink]="['/', 'wells']">View Archived Wells</button>
      </ng-container>
    </div>
  </div>
  <mat-menu #sortMenu="matMenu">
    <button mat-menu-item (click)="clearCustomSort()">By Alpha</button>
  </mat-menu>

  <div *ngIf="(isLoading$ | async) === false; else loading">
    <div *ngIf="fracs$ | async as fracs">
      <div *ngIf="fracs.length > 0; else noFracs">
        <div class="grid grid-cols-1 xl:grid-cols-2 gap-2 p-2 scrollable-content" cdkDropListGroup cdkScrollable>
          <ng-container *ngFor="let frac of fracArray; let i = index; trackBy: trackById">
            <div
              class="frac-shadow"
              cdkDropList
              cdkDropListOrientation="horizontal"
              [cdkDropListData]="{ item: frac, index: i }"
              (cdkDropListDropped)="drop($event)"
            >
              <div *cdkDragPlaceholder></div>
              <a
                [routerLink]="['/', 'lmo', 'frac', frac.lmoFracSummary.id]"
                class="frac flex flex-col h-full w-full justify-start"
                cdkDrag
                draggable="false"
              >
                <div
                  class="fracCardHeader flex flex-row justify-between items-center w-full"
                  [class.fracCardHeaderDown]="!frac.lmoFracSummary.available"
                >
                  <div class="w-full flex flex-row">
                    <div class="drag-handle px-1">
                      <mat-icon cdkDragHandle>drag_indicator</mat-icon>
                    </div>
                    <h3>
                      {{ frac.lmoFracSummary.name }}
                    </h3>
                  </div>
                  <i *ngIf="!frac.lmoFracSummary.available" class="material-icons px-2">warning</i>
                </div>
                <div class="grid grid-cols-2 gap-2 p-1 px-2">
                  <div class="flex flex-col">
                    <div *ngIf="frac.lmoFracSummary.currentStage > 1" class="flex flex-row mb-1">
                      <div>
                        <span
                          class="text-black font-bold"
                          [class.warning]="
                            frac.lmoFracSummary.minutesUntilNPT !== null && frac.lmoFracSummary.minutesUntilNPT <= 240
                          "
                        >
                          <span
                            *ngIf="
                              frac?.lmoFracSummary?.minutesUntilNPT === null ||
                                frac.lmoFracSummary.minutesUntilNPT >= 840;
                              else npt
                            "
                            >14h+</span
                          >
                          <ng-template #npt>
                            <span>{{ frac.lmoFracSummary.minutesUntilNPT | minutesToHuman }}</span>
                          </ng-template>
                        </span>
                        Until NPT
                      </div>
                      <span class="divider divider-handheld">•</span>
                      <div>
                        <span
                          class="text-black font-bold"
                          [class.warning]="
                            frac.lmoFracSummary.minutesUntilNPTNoPending !== null &&
                            frac.lmoFracSummary.minutesUntilNPTNoPending <= 300
                          "
                        >
                          <span
                            *ngIf="
                              frac?.lmoFracSummary?.minutesUntilNPTNoPending === null ||
                                frac.lmoFracSummary.minutesUntilNPTNoPending >= 840;
                              else nptNoPending
                            "
                            >14h+</span
                          >
                          <ng-template #nptNoPending>
                            <span>{{ frac.lmoFracSummary.minutesUntilNPTNoPending | minutesToHuman }}</span>
                          </ng-template>
                        </span>
                        Excluding Pending Orders
                      </div>
                    </div>
                    <div *ngIf="frac.lmoFracSummary.currentStage > 1" class="flex flex-row mb-1">
                      <div>
                        Stage <span class="font-bold">{{ frac.lmoFracSummary.currentStage }}</span> of
                        <span class="font-bold">{{ frac.lmoFracSummary.totalStages }}</span>
                      </div>
                      <div class="divider hide-handheld">•</div>
                      <div class="stage">
                        Last stage completed
                        <span class="font-bold">{{ frac.lmoFracSummary.previousStageCompletedTime | ago }}</span>
                      </div>
                    </div>
                    <div class="flex flex-col">
                      <div class="inline-block">
                        <a
                          class="ordersLink"
                          [routerLink]="['/', 'lmo', 'frac', frac.lmoFracSummary.id, 'orders', 'pending']"
                        >
                          Pending <span class="font-bold">{{ frac.lmoFracSummary.pendingOrderCount }}</span>
                        </a>
                        <div class="divider hide-handheld">•</div>
                        <a
                          class="ordersLink"
                          [routerLink]="['/', 'lmo', 'frac', frac.lmoFracSummary.id, 'orders', 'in-progress']"
                        >
                          <span
                            >In Progress
                            <span
                              class="font-bold"
                              *ngIf="
                                (statsLoading$ | async) && frac.lmoFracSummary.inProgressOrderCount === 0;
                                else inProgressCount
                              "
                            >
                              <mat-spinner class="inline-count-spinner" [diameter]="16"></mat-spinner>
                            </span>
                            <ng-template #inProgressCount>
                              <span class="font-bold">{{ frac.lmoFracSummary.inProgressOrderCount }}</span>
                            </ng-template></span
                          >
                        </a>
                        <div class="ordersNoLink">
                          <ng-container *ngIf="frac.lmoFracSummary.upForGrabsOrderCount > 0">
                            <div class="divider hide-handheld">•</div>
                            <span
                              >Up For Grabs
                              <span class="font-bold">{{ frac.lmoFracSummary.upForGrabsOrderCount }}</span>
                            </span>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                    <div
                      *ngIf="frac.lmoFracSummary.currentStage <= 1 || frac.lmoFracSummary.allMinesDown"
                      class="fracCardIndicatorList flex flex-row gap-1 mt-1 w-full py-1"
                    >
                      <div class="pill prefillPill" *ngIf="frac.lmoFracSummary.currentStage <= 1">Prefill</div>
                      <div class="pill noSandPill" *ngIf="frac.lmoFracSummary.allMinesDown">No Sand</div>
                    </div>
                  </div>
                  <div class="sections flex flex-col gap-1 text-sm">
                    <a
                      [routerLink]="[
                        '/',
                        'lmo',
                        'frac',
                        frac.lmoFracSummary.id,
                        'home',
                        'lmo_frac_home_modal',
                        'trucking_vendor',
                        'manage',
                        vendor.fctvId
                      ]"
                      class="vendor vendor-link flex flex-col w-full"
                      *ngFor="let vendor of frac.vendorDetails; trackBy: trackByFctvId"
                    >
                      <div>
                        <div class="vendor_name strong">
                          {{ vendor.truckingVendorName }}
                        </div>
                      </div>
                      <div>
                        <div class="vendor_in_progress" *ngIf="statsLoading$ | async; else vendorInProgress">
                          <mat-spinner class="inline-count-spinner" [diameter]="16"></mat-spinner>
                        </div>
                        <ng-template #vendorInProgress>
                          <div class="vendor_in_progress">
                            {{ vendor.inProgressOrderCount }} in-progress
                            <span matTooltip="Current Distribution"
                              >({{ vendor.currentTruckPoolAllocationPercent }}%)</span
                            >
                          </div>
                        </ng-template>
                      </div>
                      <div class="flex flex-row items-center">
                        <mat-progress-bar
                          mode="determinate"
                          [value]="vendor.awardedAllocationPercent"
                          class="flex-grow rounded-full"
                        ></mat-progress-bar>
                        <div class="text-xs font-bold pl-2">{{ vendor.awardedAllocationPercent }}%</div>
                      </div>
                    </a>
                    <a
                      class="overflow"
                      [routerLink]="[
                        '/',
                        'lmo',
                        'frac',
                        frac.lmoFracSummary.id,
                        'home',
                        'lmo_frac_home_modal',
                        'trucking_vendor',
                        'overflow_vendors'
                      ]"
                    >
                      <div class="details">
                        <div
                          class="vendor_name strong"
                          [class.no-overflow-warning]="(frac.overflowVendorDetails || []).length === 0"
                        >
                          + {{ (frac.overflowVendorDetails || []).length | i18nPlural: overflowTruckingVendors }}
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </a>
            </div>
          </ng-container>
        </div>
      </div>
      <ng-template #noFracs>
        <div class="flex flex-col items-center w-full py-5">
          <img class="emptyScreenIcon" src="../../../assets/icons/lmo-rig.svg" />
          <span class="text-lg font-semibold">No Wells</span>
          <span class="text-base text-gray-700">You are currently not subscribed to any active wells.</span>
        </div>
      </ng-template>
    </div>
  </div>
  <ng-template #loading>
    <div class="loading py-5">
      <mat-spinner></mat-spinner>
    </div>
  </ng-template>
</div>
<ng-template #loading>
  <div class="loading">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
<router-outlet></router-outlet>
